import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Syncs fulfillment / lead-time markup from the section response when variants change.
 *
 * @typedef {Object} ProductVariantFulfillmentRefs
 * @property {HTMLElement} fulfillmentRoot
 *
 * @extends {Component<ProductVariantFulfillmentRefs>}
 */
class ProductVariantFulfillment extends Component {
  requiredRefs = ['fulfillmentRoot'];

  /** @type {HTMLElement | null} */
  #variantListenTarget = null;

  connectedCallback() {
    super.connectedCallback();

    this.#variantListenTarget =
      this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card') ??
      this.closest('.shopify-section');

    if (!this.#variantListenTarget) {
      return;
    }

    this.#variantListenTarget.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#variantListenTarget) {
      this.#variantListenTarget.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    }
    this.#variantListenTarget = null;
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = event.detail.data.html.querySelector(
      `product-variant-fulfillment[data-product-id="${this.dataset.productId}"]`
    );
    const nextRoot = next?.querySelector('[ref="fulfillmentRoot"]');
    if (!nextRoot || !this.refs.fulfillmentRoot) {
      return;
    }

    this.refs.fulfillmentRoot.innerHTML = nextRoot.innerHTML;
  };
}

if (!customElements.get('product-variant-fulfillment')) {
  customElements.define('product-variant-fulfillment', ProductVariantFulfillment);
}
